module.exports = __webpack_public_path__ + "static/media/landscape2.64ca4e53.jpg";